module.exports = __webpack_public_path__ + "static/media/activity_v2.0bf99345.jpg";